// import { useSelector } from "react-redux";
import styled from "styled-components";
import { LiaTimesSolid } from "react-icons/lia";
import { IoCheckmarkOutline } from "react-icons/io5";

import Overlay from "../overlay";
import GeneralBtn from "../generalBtn";

interface ConfirmationModalProps {
  handleCloseModal: () => void;
  handleRemoveItem?: any;
  modalMessage?: string;
  isOverlayModal?: boolean;
}

const ConfirmationModal = ({
  handleCloseModal,
  handleRemoveItem,
  modalMessage,
  isOverlayModal,
}: ConfirmationModalProps) => {
  // const { isOverlayModal } = useSelector((store) => store.addStockStore);

  return (
    <>
      {isOverlayModal && (
        <Overlay handleClick={handleCloseModal}>
          <ConfirmationModalWrapper
            className="bg-[#fff] px-4 py-6 rounded-lg shadow-lg z-[10]"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="">{modalMessage}?</p>
            <div className="confirmation__btns__con">
              <GeneralBtn
                icon={<LiaTimesSolid />}
                btnStyle={`dont__remove__btn confirmation__btn`}
                handleClick={handleCloseModal}
              />
              <GeneralBtn
                icon={<IoCheckmarkOutline />}
                btnStyle={`remove__btn confirmation__btn`}
                handleClick={handleRemoveItem}
              />
            </div>
          </ConfirmationModalWrapper>
        </Overlay>
      )}
    </>
  );
};

export default ConfirmationModal;

const ConfirmationModalWrapper = styled.div`
  background-color: #fff;
  padding: 20px 1rem;
  border-radius: 1rem;
  z-index: 10;

  > p {
    font-size: 20px;
    max-width: 300px;
    text-align: center;
  }

  .confirmation__btn {
    border-radius: 100%;
    font-size: 2rem;
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    color: #fff;
  }

  @media screen and (max-width: 540px) {
    .confirmation__btn {
      font-size: 20px;
      height: 48px;
      width: 48px;
    }
  }

  .confirmation__btns__con {
    display: flex;
    width: fit-content;
    margin: 12px auto 0;
    gap: 1rem;
  }

  .dont__remove__btn {
    background-color: red;
  }
  .remove__btn {
    background-color: green;
  }
`;
